<template>
  <div
    class="option-container d-flex align-center"
    :class="{ 'w-full': $vuetify.display.xs }"
  >
    <!-- TODO: check missing offset-y prop -->
    <v-menu location="bottom">
      <template v-slot:activator="{ props }">
        <!-- TODO: add outlined style -->
        <!-- variant="outlined" -->
        <v-btn
          variant="text"
          :color="leadsViewSelected === 'pipeline' ? 'primary' : 'rgba(0, 0, 0, 0.50)'"
          v-bind="props"
          class="px-2 camel-case option-btn"
          @click="$emit('select')"
        >
          <v-icon start> mdi-dots-grid </v-icon>
          {{ $t('labels.contacts.pipeline') }}
        </v-btn>
      </template>
    </v-menu>
  </div>
</template>

<script>
import brandingMixin from '@/mixins/branding'

export default {
  mixins: [brandingMixin],
  props: {
    leadsViewSelected: {
      type: String,
      required: false,
    },
  },
  emits: ['select'],
}
</script>

<style scoped>
.option-btn {
  text-transform: uppercase !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.5px;
  border: none;
  position: relative;
}

.option-btn::before {
  content: '';
  position: absolute;
  top: 20%;
  left: 0;
  width: 1px;
  height: calc(100% - 40%);
  background-color: #e4e4e4;
}

@media (max-width: 600px) {
  .option-container {
    height: unset !important;
  }
}

@media (min-width: 600px) {
  .option-container {
    height: 50px !important;
  }
}

@media (min-width: 1252px) and (max-width: 1430px) {
  .option-container {
    margin-right: 10px;
  }
}
</style>
